// extracted by mini-css-extract-plugin
export var thankYouBackgroundWrapper = "styles-module--thankYouBackgroundWrapper--1u4tF";
export var thankYouBackground = "styles-module--thankYouBackground--qPTie";
export var closeModal = "styles-module--closeModal--2l2I1";
export var info = "styles-module--info--1yU7L";
export var icon = "styles-module--icon--1tZPx";
export var header = "styles-module--header--2-ru_";
export var subHeader = "styles-module--subHeader--1N2Au";